import Axios from './axios'
import user from './user'
import auth from './auth'
import channel from './channel'

const apis = {
  axios: Axios,
  user,
  auth,
  channel
}

export default apis
